import { addAsync as _addAsync, getAsync as _getAsync } from "../../api";

const BASE_URL = "/settings/invoicing-issuers";

export async function addAsync(data) {
    return _addAsync({ url: BASE_URL, data });
}

export async function getAsync() {
    return _getAsync({ url: `${BASE_URL}/latest` });
}
